// extracted by mini-css-extract-plugin
module.exports = {"btnWithAddon":"index_btnWithAddon_2-LsL","btnAddon":"index_btnAddon_3HBiq","btnAddonIcon":"index_btnAddonIcon_3BVa7"};